module.exports = __webpack_public_path__ + "static/media/Source Info.8965010e.txt";